import React, { useState, useEffect } from 'react';
import { getCookie, setCookie } from 'stash/utils/cookies';
import { cookieNames } from 'stash/utils/native-bridge';

interface NativeAuthProviderProps {
	children: React.ReactNode;
}

export const NativeAuthProvider = ({ children }: NativeAuthProviderProps) => {
	const [auth, setAuth] = useState({
		accessToken: decodeURIComponent(getCookie(cookieNames.STASH_ACCESS_TOKEN) || ''),
		refreshToken: getCookie(cookieNames.STASH_REFRESH_TOKEN),
		uuid: getCookie(cookieNames.STASH_UUID),
	});

	useEffect(() => {
		auth.accessToken &&
			setCookie(cookieNames.STASH_ACCESS_TOKEN, encodeURIComponent(auth.accessToken));
		auth.uuid && setCookie(cookieNames.STASH_UUID, auth.uuid);
		auth.refreshToken && setCookie(cookieNames.STASH_REFRESH_TOKEN, auth.refreshToken);
	}, [auth.accessToken, auth.uuid, auth.refreshToken]);

	// Expose global function for native to refresh access tokens periodically
	window.setAccessToken = (accessToken: string) => {
		console.log('NativeAuth Client :: setAccessToken func called');
		setAuth((prevAuth) => ({
			...prevAuth,
			accessToken,
		}));
	};

	return <>{children}</>;
};

